import { Flex, FlexProps } from "@chakra-ui/react"
import React, { forwardRef } from "react"

/**
 * Used for displaying overlapping avatars in a series.
 *
 * Note: if you want each child Avatar wrapped in a Tooltip, remember to use the
 * `shouldWrapChildren` prop on the Tooltip component.
 *
 * @example
 * <AvatarGroup>
 *   <Avatar appearance="generic" />
 *   <Avatar appearance="generic" />
 * </AvatarGroup>
 */
export const AvatarGroup = forwardRef<
  HTMLDivElement,
  { children: React.ReactNode } & Omit<FlexProps, "children">
>(({ children, ...props }, ref) => {
  return (
    <Flex
      ref={ref}
      {...props}
      sx={{
        "& [data-ui='ds-avatar']": {
          border: "1px solid",
          borderColor: "ds.border.inverse",
        },
        // Second selector here is for edge cases when
        // each child Avatar is wrapped in a tooltip
        "& [data-ui='ds-avatar']:not(:first-child), & :has(> [data-ui='ds-avatar']):not(:first-child) [data-ui='ds-avatar']":
          {
            ml: -3,
          },
      }}
    >
      {children}
    </Flex>
  )
})

AvatarGroup.displayName = "AvatarGroup"
